import { render, staticRenderFns } from "./RenameCollection.vue?vue&type=template&id=18741783&scoped=true&"
import script from "./RenameCollection.vue?vue&type=script&lang=js&"
export * from "./RenameCollection.vue?vue&type=script&lang=js&"
import style0 from "./RenameCollection.vue?vue&type=style&index=0&id=18741783&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18741783",
  null
  
)

export default component.exports